import { render } from "./PolicyAccount.vue?vue&type=template&id=3b2c4f00&scoped=true"
import script from "./PolicyAccount.vue?vue&type=script&lang=js"
export * from "./PolicyAccount.vue?vue&type=script&lang=js"

import "./PolicyAccount.vue?vue&type=style&index=0&id=3b2c4f00&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2c4f00"]])

export default __exports__